import React from 'react';
import { cn } from '../lib/utils';

/**
 * TableOfContents renders a list of heading links.
 * Expects an array of objects: [{ id, text, level }]
 */
export function TableOfContents({ headings }) {
  if (!headings || headings.length === 0) return null;

  return (
    <nav
      aria-label="Table of contents"
      className={cn(
        'rounded-lg border border-gray-200 dark:border-gray-700 bg-white/60 dark:bg-neutral-900/60 backdrop-blur-sm',
        'p-5 mb-12 text-sm shadow-sm'
      )}
    >
      <p className="font-medium text-gray-700 dark:text-gray-300 mb-3">Contents</p>
      <ul className="space-y-2">
        {headings.map(h => (
          <li key={h.id} className={cn(h.level > 2 && 'ml-4')}> 
            <a
              href={`#${h.id}`}
              className="block text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors"
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default TableOfContents;